// App.js

import React, { useMemo, useState, useEffect, setFilter  } from "react";
import { Card, Container, Row, Button, Col } from 'react-bootstrap';
import Table from "./Table";
import styled from "styled-components";
import "../../css/bootstrap.min.css";
import "../../css/react-table.css";
import cardCss from '../../components/UI/Card/Card.css';
import Spinner  from '../../components/Spinner/Spinner';
import LoadingGif from '../../components/Loading/Loading'
import { FaBlog,FaEdit,FaFilePdf } from 'react-icons/fa';
import { RiVideoAddFill } from "react-icons/ri";
import { FaCheckCircle, FaChild } from "react-icons/fa";
import {AiFillAudio} from "react-icons/ai"
import tableCss from './Table.css';
import {GrDocumentPdf,GrEdit} from 'react-icons/gr';
import { Router, Route, Switch, withRouter, useHistory, useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

const axios = require('axios');

function SortingTableComponent(props) {
  const [data, setData] = useState([]);
  const [object, setObject] = useState({});
  const [filterdata, setFilterdata] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const[ageallflag,setAgeallflag]=useState(true);
  const[agekidsflag,setAgekidsflag]=useState(false);
  const[ageadultsflag,setAgeadultsflag]=useState(false);
  
  const[btypeAllFlag,setBtypeAllFlag]=useState(true);
  const[bytpePdfFlag,setBtypePdfFlag]=useState(false);
  const[btypeAudioFlag,setBtypeAudioFlag]=useState(false);

  const[langallflag,setLangallflag]=useState(true);
  const[langengflag,setLangengflag]=useState(false);
  const[langurduflag,setLangurduflag]=useState(false);

  const [books, setBooks] = useState({});
  const[blogsAvail, setBlogsavail] = useState({});
  const[vlogsAvail, setVlogsavail] = useState({});

  useEffect(() => {
    (async () => {

      var blogAvail = {};
      axios.get( 'https://abc1-ceaf0-default-rtdb.firebaseio.com/blogData.json')
      .then( res => {
      const blogData = res.data;
      Object.keys(blogData).forEach(function (key) {
          var value = blogData[key];
          var pdfId = value.pdfId
          blogAvail[pdfId] = pdfId;
      });
      });
      setBlogsavail(blogAvail);

      var vlogAvail = {};
      axios.get( 'https://abc1-ceaf0-default-rtdb.firebaseio.com/vlogData.json')
      .then( res => {
      const vlogData = res.data;
      Object.keys(vlogData).forEach(function (key) {
          var value = vlogData[key];
          var pdfId = value.pdfId
          vlogAvail[pdfId] = pdfId;
      });
      });
      setVlogsavail(vlogAvail);
      
      setLoading(true);
      axios.get('https://abc1-ceaf0-default-rtdb.firebaseio.com/pdfMetadata.json')
      .then((response) => {
        const pdf_data = response.data;

        setLoading(false);
        setObject(pdf_data);
        const newArray = new Array();
        var i=0;
        for (var key in pdf_data) {
            if (pdf_data.hasOwnProperty(key)) {           
                console.log(key, pdf_data[key]);
                var pair = {id: key};
                var obj = pdf_data[key];

                let blogAvailClass = "outline-secondary";
                if(blogAvail[key])
                {
                  blogAvailClass="secondary";
                }

                let vlogAvailClass = "outline-secondary";
                if(vlogAvail[key])
                {
                  vlogAvailClass="secondary";
                }

                var classVar = {blogAvailClass:blogAvailClass,vlogAvailClass:vlogAvailClass};


                newArray.push({...obj,...pair,...classVar});
                i++;
            }
        }
                
        setData(newArray);
        setFilterdata(newArray);
      })
      .catch(error => {
        console.log(error)
      })



   
  



    })();
  }, []);


  const Styles = styled.div`
  padding: 0rem;

  table {
    border-spacing: 0;
    border: 1px solid black;
    width:100%;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.2rem;
      border: 1px solid black;
      font-family: sans-serif;
      color: #464444;
      padding: 4px 4px 4px 8px;
      :last-child {
        border-right: 0;
      }
      a {
        color: #0654a2;
      }
      
    }
  }
`

const history = useHistory();

const routeUploadPdf=()=> {
  let path = `/FirebaseFileUpload`;
  history.push(path);
  }

const routeChange=(pathExt, param1)=> {
  let path = `/`+pathExt;
  props.history.push(path, {'id':param1});

  }

  
const updateAgeAllFlag=()=> {
  setAgeallflag(!ageallflag);
  setAgeadultsflag(false);
  setAgekidsflag(false);
}

const updateAgeAdultsFlag=()=> {
  setAgeadultsflag(!ageadultsflag);
  setAgeallflag(false);
}
const updateAgeKidsFlag=()=> {
  setAgekidsflag(!agekidsflag);
  setAgeallflag(false);
}

const updateBtypeAllFlag=()=> {
  setBtypeAllFlag(!btypeAllFlag);
  setBtypePdfFlag(false);
  setBtypeAudioFlag(false);
}

const updateBtypePdfFlag=()=> {
  setBtypePdfFlag(!bytpePdfFlag);
  setBtypeAllFlag(false);
}
const updateBtypeAudioFlag=()=> {
  setBtypeAudioFlag(!btypeAudioFlag);
  setBtypeAllFlag(false);
}

const updateLangAllFlag=()=> {
  setLangallflag(!langallflag);
  setLangengflag(false);
  setLangurduflag(false);
}
const updateLangEngFlag=()=> {
  setLangengflag(!langengflag);
  setLangallflag(false);
}
const updateLangUrduFlag= ()=> {
  setLangurduflag(!langurduflag);
  setLangallflag(false);
}

useEffect(() => {
  //alert("langUrdu:"+langurduflag+":langEng:"+langengflag+":langall:"+langallflag);
  const newArray = new Array();
  setFilterdata([]);
  for (var key in object) {
    if (object.hasOwnProperty(key)) {           
        console.log(key, object[key]);
        var pair = {id: key};
        var obj = object[key];

        let blogAvailClass = "outline-secondary";
        if(blogsAvail[key])
        {
          blogAvailClass="secondary";
        }

        let vlogAvailClass = "outline-secondary";
        if(vlogsAvail[key])
        {
          vlogAvailClass="secondary";
        }

        var classVar = {blogAvailClass:blogAvailClass,vlogAvailClass:vlogAvailClass};

        if(langallflag == true)
        {
          newArray.push({...obj,...pair,...classVar});
        }
        if(langallflag == false && ((obj['language'] == 'Urdu') && (langurduflag == true)))
        {
          //alert("language:"+obj['language']+":urdu:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }
        if(langallflag == false && ((obj['language'] == 'English') && (langengflag == true)))
        {
          //alert("language:"+obj['language']+":english:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }

      }
  }
        
  setFilterdata(newArray);

}, [langallflag,langurduflag,langengflag]);


useEffect(() => {
  //alert("agekid:"+agekidsflag+":ageadult:"+ageadultsflag);
  const newArray = new Array();
  setFilterdata([]);
  for (var key in object) {
    if (object.hasOwnProperty(key)) {           
        console.log(key, object[key]);
        var pair = {id: key};
        var obj = object[key];

        let blogAvailClass = "outline-secondary";
        if(blogsAvail[key])
        {
          blogAvailClass="secondary";
        }

        let vlogAvailClass = "outline-secondary";
        if(vlogsAvail[key])
        {
          vlogAvailClass="secondary";
        }
        var classVar = {blogAvailClass:blogAvailClass,vlogAvailClass:vlogAvailClass};

        if(ageallflag == true)
        {
          newArray.push({...obj,...pair,...classVar});
        }
        if(ageallflag == false && ((obj['age'] == 'kids') && (agekidsflag == true)))
        {
          //alert("language:"+obj['language']+":urdu:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }
        if(ageallflag == false && ((obj['age'] == 'adults') && (ageadultsflag == true)))
        {
          //alert("language:"+obj['language']+":english:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }
    }
  }
        
  setFilterdata(newArray);


}, [ageallflag,agekidsflag,ageadultsflag]);



useEffect(() => {
  //alert("agekid:"+agekidsflag+":ageadult:"+ageadultsflag);
  const newArray = new Array();
  setFilterdata([]);
  for (var key in object) {
    if (object.hasOwnProperty(key)) {           
        console.log(key, object[key]);
        var pair = {id: key};
        var obj = object[key];

        let blogAvailClass = "outline-secondary";
        if(blogsAvail[key])
        {
          blogAvailClass="secondary";
        }

        let vlogAvailClass = "outline-secondary";
        if(vlogsAvail[key])
        {
          vlogAvailClass="secondary";
        }
        var classVar = {blogAvailClass:blogAvailClass,vlogAvailClass:vlogAvailClass};

        if(btypeAllFlag == true)
        {
          newArray.push({...obj,...pair,...classVar});
        }
        if(btypeAllFlag == false && ((obj['booktype'] == 'audio') && (btypeAudioFlag == true)))
        {
          //alert("language:"+obj['language']+":urdu:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }
        if(btypeAllFlag == false && ((obj['booktype'] == 'pdf' || (obj['booktype'] == null )) && (bytpePdfFlag == true)))
        {
          //alert("language:"+obj['language']+":english:langallflag:"+langallflag);
          newArray.push({...obj,...pair,...classVar});
        }
    }
  }
        
  setFilterdata(newArray);


}, [btypeAllFlag,btypeAudioFlag,bytpePdfFlag]);



const columns = useMemo(
    () => [
        {
            initialState: {
            sortBy: [
                {
                    id: 'title',
                    desc: true,
                }
            ]
            },
            Header: " ",
          // First group columns
            columns: [
            {
                Header: "Title",
                accessor: "title",
                id: "title",
                Cell: ({ row }) => 
                {
                  let titleIcon = "";
                  if(row.original.age == 'kids')
                  {
                    titleIcon = <FaChild color="green" />;
                  }
                  let btypeIcon = <FaFilePdf/>;
                  if(row.original.booktype == 'audio')
                  {
                    btypeIcon = <AiFillAudio/>;
                  }

                    if(props.userEmail == row.original.uploader){
                        return <span> <a href={row.original.url} target='_blank'><b><span style={{fontWeight:'bold', fontSize: '1.5em'}}>{row.original.title} {titleIcon}</span></b></a> 
                              {/* <br></br><a href=''  onClick={(event) => {routeChange("BlogMain", row.original.id)}}><Button variant={row.original.blogAvailClass} style={{fontSize:'1.0em'}}>Blog <FaBlog/></Button></a> <a href='' onClick={routeChange.bind(this, 'VlogMain', row.original.id)}><Button variant={row.original.vlogAvailClass} style={{fontSize:'1.0em'}}>Vlog <RiVideoAddFill/></Button></a> <a href={row.original.url} target='_blank'><Button variant="secondary" style={{fontSize:'1.0em',color:'white'}}>PDF <FaFilePdf/></Button></a> <a href=''  onClick={(event) => {routeChange("UpdateFileData", row.original.id)}}><Button variant="secondary" style={{fontSize:'1.0em'}}>Edit <FaEdit/></Button></a>   */}
                              <br></br><a href=''  onClick={(event) => {routeChange("MultiBlog", row.original.id)}}><Button variant={row.original.blogAvailClass} style={{fontSize:'1.0em'}}>Blog <FaBlog/></Button></a> <a href='' onClick={routeChange.bind(this, 'VlogMain', row.original.id)}><Button variant={row.original.vlogAvailClass} style={{fontSize:'1.0em'}}>Vlog <RiVideoAddFill/></Button></a> <a href={row.original.url} target='_blank'><Button variant="secondary" style={{fontSize:'1.0em',color:'white'}}>Book {btypeIcon}</Button></a> <a href=''  onClick={(event) => {routeChange("UpdateFileData", row.original.id)}}><Button variant="secondary" style={{fontSize:'1.0em'}}>Edit <FaEdit/></Button></a>  
                              <br></br><b>Author:</b> {row.original.author}
                              <br></br><b>Language:</b> {row.original.language}
                              <br></br><b>Pages/Minutes:</b> {row.original.pgCnt}
                              <br></br><b>Tags:</b> {row.original.tags}
                            </span>
                          }
                        else{
                          return <span> <a href={row.original.url} target='_blank'><b><span style={{fontWeight:'bold', fontSize: '1.5em'}}>{row.original.title} {titleIcon}</span></b></a> 
                            {/* <br></br><a href=''  onClick={(event) => {routeChange("BlogMain", row.original.id)}}><Button variant={row.original.blogAvailClass} style={{fontSize:'1.0em'}}>Blog <FaBlog/></Button></a> <a href='' onClick={routeChange.bind(this, 'VlogMain', row.original.id)}><Button variant={row.original.vlogAvailClass} style={{fontSize:'1.0em'}}>Vlog <RiVideoAddFill/></Button></a>  <a href={row.original.url} target='_blank'><Button variant="secondary" style={{fontSize:'1.0em'}}>PDF <FaFilePdf/></Button></a>  */}
                            <br></br><a href=''  onClick={(event) => {routeChange("MultiBlog", row.original.id)}}><Button variant={row.original.blogAvailClass} style={{fontSize:'1.0em'}}>Blog <FaBlog/></Button></a> <a href='' onClick={routeChange.bind(this, 'VlogMain', row.original.id)}><Button variant={row.original.vlogAvailClass} style={{fontSize:'1.0em'}}>Vlog <RiVideoAddFill/></Button></a>  <a href={row.original.url} target='_blank'><Button variant="secondary" style={{fontSize:'1.0em'}}>Book {btypeIcon}</Button></a> 
                            <br></br><b>Author:</b> {row.original.author}
                            <br></br><b>Language:</b> {row.original.language}
                            <br></br><b>Pages/Minutes:</b> {row.original.pgCnt}
                            <br></br><b>Tags:</b> {row.original.tags}
                          </span>
                        }
                }
            },
            {
              Header: "Author",
              accessor: "author",
            },
            {
              Header: "Language",
              accessor: "language",
            },
            {
              Header: "Page Count",
              accessor: "pgCnt",
            },
            {
                Header: "Tags",
                accessor: "tags",
            },
            {
              Header: "Age",
              accessor: "age",
            },
          ],
        },
      ],
      []
    );
  
  const hiddenColumns = ["url","tags","author","pgCnt","language","age"]; 

  const downloadHeaders = [
    { label: "Title", key: "title" },
    { label: "Author", key: "author" },
    { label: "Page Count", key: "pgCnt" },
    { label: "Tags", key: "tags" },
    { label: "URL", key: "url" },

  ];
//  alert("data:"+JSON.stringify(data));
  let tableDom = <Table columns={columns} data={filterdata} hiddenColumns={hiddenColumns} downloadHeaders={downloadHeaders} />;
  if(isLoading){
    tableDom = <LoadingGif />
  }
  
  if(props.isAuthenticated)
  {
    let btn_langallflag = langallflag ? "btn btn-dark" : "btn";
    let btn_langurduflag = langurduflag ? "btn btn-dark" : "btn";
    let btn_langengflag = langengflag ? "btn btn-dark" : "btn";

    let btnclass1 = false;
    let btn_text = btnclass1 ? "Hide Filters" : "Show Filters";
    let div_show = btnclass1 ? "block" : "none";

    return (  <div style={{'display': 'flex', 'justifyContent': 'center', height:'100%', 'alignItems': 'left','paddingTop':'0px'}}>

        <div className='panel panel-default align-items-center p-3 my-3' style={{'width':'1500px', 'paddingTop':'0px', height:'100%', 'overflow':'scroll'}}>
            <div className='align-items-center p-3 my-3 rounded shadow panel-heading' style={{'boxShadow':'0 4px 8px 0 #042a4a', 'transition': '0.3s',"backgroundColor":"#042a4a",'color':"#3d4bb8","textAlign":"left", 'width':'98%', "align":"left"}}>
                    <span style={{fontWeight:'bold', fontSize:'1.2em', textAlign:"left", color:"white", backgroundColor:"#042a4a"}}>Book List</span>
            </div>
             <div className='align-items-center p-3 my-3 rounded shadow panel-body' style={{height:'100%','valign':'top','overflow': 'scroll','width':'98%'}}> 
             
             <div className={tableCss.filterDiv}>
               <div className={tableCss.filterSpan}>Upload Book </div>
               <div style={{textAlign:'left'}}><Button variant="dark" className="px-4" style={{fontSize:"15px", backgroundColor:'#6c757d'}} onClick={routeUploadPdf}>Upload</Button></div>
             </div>
             
            <br></br>

             <div className={tableCss.filterDiv}>
             <div className={tableCss.filterSpan}>Filters </div>
                <div className={tableCss.switchfield}> 
                  {ageallflag ? <button name="ageall"  className="btn btn-secondary" onClick={updateAgeAllFlag}><FaCheckCircle/> All</button> : <button name="ageall"  className="btn" onClick={updateAgeAllFlag}>All</button> }
                  {ageadultsflag ? <button name="ageadults"  className="btn btn-secondary" onClick={updateAgeAdultsFlag}><FaCheckCircle/> Adults</button> : <button name="ageadults"  className="btn" onClick={updateAgeAdultsFlag}>Adults</button> }
                  {agekidsflag ? <button name="agekidsflag"  className="btn btn-secondary" onClick={updateAgeKidsFlag}><FaCheckCircle/> Kids</button> : <button name="agekids"  className="btn" onClick={updateAgeKidsFlag}>Kids</button> }
                </div>
                <div className={tableCss.switchfield}> 
                  {langallflag ? <button name="langall"  className="btn btn-secondary" onClick={updateLangAllFlag}><FaCheckCircle/> All</button> : <button name="langall"  className="btn" onClick={updateLangAllFlag}>All</button> }
                  {langengflag ? <button name="langenglish"  className="btn btn-secondary" onClick={updateLangEngFlag}><FaCheckCircle/> English</button> : <button name="langenglish"  className="btn" onClick={updateLangEngFlag}>English</button> }
                  {langurduflag ? <button name="langurdu"  className="btn btn-secondary" onClick={updateLangUrduFlag}><FaCheckCircle/> Urdu</button> : <button name="langurdu"  className="btn" onClick={updateLangUrduFlag}>Urdu</button> }
          	    </div>
                <div className={tableCss.switchfield}> 
                  {btypeAllFlag ? <button name="btypeall"  className="btn btn-secondary" onClick={updateBtypeAllFlag}><FaCheckCircle/> All</button> : <button name="btypeall"  className="btn" onClick={updateBtypeAllFlag}>All</button> }
                  {bytpePdfFlag ? <button name="btypepdf"  className="btn btn-secondary" onClick={updateBtypePdfFlag}><FaCheckCircle/> PDF</button> : <button name="btypepdf"  className="btn" onClick={updateBtypePdfFlag}>PDF</button> }
                  {btypeAudioFlag ? <button name="btypeaudio"  className="btn btn-secondary" onClick={updateBtypeAudioFlag}><FaCheckCircle/> Audio</button> : <button name="btypeaudio"  className="btn" onClick={updateBtypeAudioFlag}>Audio</button> }
          	    </div>
             </div>
             <br></br>

              <Styles>{tableDom}</Styles>
            </div>
        </div>
        <br></br><br></br>
    </div>  
    );
  }
  else
  {
    return (  <div style={{'display': 'flex', 'justifyContent': 'center', height:'100%', 'alignItems': 'left',padding:'2px 2px'}}>

        <div className='panel panel-default align-items-center p-3 my-3' style={{'width':'1500px', paddingTop:'2px 2px', height:'100%', 'overflow':'scroll'}}>
            <div className='align-items-center p-3 my-3 rounded shadow panel-heading' style={{'boxShadow':'0 4px 8px 0 #042a4a', 'transition': '0.3s',"backgroundColor":"#042a4a",'color':"#3d4bb8","textAlign":"left", 'width':'95%', "align":"left"}}>
                    <span style={{fontWeight:'bold', fontSize:'1.2em', textAlign:"left", color:"white", backgroundColor:"#042a4a"}}>Book List</span>
            </div>
             <div className='align-items-center p-3 my-3 rounded shadow panel-body' style={{height:'100%','valign':'top','overflow': 'scroll','width':'95%'}}> 


             <div className={tableCss.filterDiv}>
             <div className={tableCss.filterSpan}>Filters </div>
                <div className={tableCss.switchfield}> 
                  {ageallflag ? <button name="ageall"  className="btn btn-secondary" onClick={updateAgeAllFlag}><FaCheckCircle/> All</button> : <button name="ageall"  className="btn" onClick={updateAgeAllFlag}>All</button> }
                  {ageadultsflag ? <button name="ageadults"  className="btn btn-secondary" onClick={updateAgeAdultsFlag}><FaCheckCircle/> Adults</button> : <button name="ageadults"  className="btn" onClick={updateAgeAdultsFlag}>Adults</button> }
                  {agekidsflag ? <button name="agekidsflag"  className="btn btn-secondary" onClick={updateAgeKidsFlag}><FaCheckCircle/> Kids</button> : <button name="agekids"  className="btn" onClick={updateAgeKidsFlag}>Kids</button> }
                </div>
                <div className={tableCss.switchfield}> 
                  {langallflag ? <button name="langall"  className="btn btn-secondary" onClick={updateLangAllFlag}><FaCheckCircle/> All</button> : <button name="langall"  className="btn" onClick={updateLangAllFlag}>All</button> }
                  {langengflag ? <button name="langenglish"  className="btn btn-secondary" onClick={updateLangEngFlag}><FaCheckCircle/> English</button> : <button name="langenglish"  className="btn" onClick={updateLangEngFlag}>English</button> }
                  {langurduflag ? <button name="langurdu"  className="btn btn-secondary" onClick={updateLangUrduFlag}><FaCheckCircle/> Urdu</button> : <button name="langurdu"  className="btn" onClick={updateLangUrduFlag}>Urdu</button> }
          	    </div>
                <div className={tableCss.switchfield}> 
                  {btypeAllFlag ? <button name="btypeall"  className="btn btn-secondary" onClick={updateBtypeAllFlag}><FaCheckCircle/> All</button> : <button name="btypeall"  className="btn" onClick={updateBtypeAllFlag}>All</button> }
                  {bytpePdfFlag ? <button name="btypepdf"  className="btn btn-secondary" onClick={updateBtypePdfFlag}><FaCheckCircle/> PDF</button> : <button name="btypepdf"  className="btn" onClick={updateBtypePdfFlag}>PDF</button> }
                  {btypeAudioFlag ? <button name="btypeaudio"  className="btn btn-secondary" onClick={updateBtypeAudioFlag}><FaCheckCircle/> Audio</button> : <button name="btypeaudio"  className="btn" onClick={updateBtypeAudioFlag}>Audio</button> }
          	    </div>

             </div>

              <br></br>


              <Styles>{tableDom}</Styles>
            </div>
        </div>
        <br></br><br></br>
    </div>  
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
    token: state.auth.token,
    org: state.auth.org,
    admin: state.auth.admin,
    userEmail: state.auth.userEmail,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
  )(SortingTableComponent)
);




// WEBPACK FOOTER //
// ./src/containers/Table/pdfTable.js